export enum BoynerOrderStatus {
  CREATED = 'Created',
  CANCELLED = 'Cancelled',
}

export const boynerOrderStatusNameMap: Record<BoynerOrderStatus, string> = {
  [BoynerOrderStatus.CREATED]: 'Sipariş Oluşturuldu',
  [BoynerOrderStatus.CANCELLED]: 'İptal Edildi',
};

export const boynerOrderStatusDescriptionMap: Record<
  BoynerOrderStatus,
  string
> = {
  [BoynerOrderStatus.CREATED]: 'Stok düşüldü',
  [BoynerOrderStatus.CANCELLED]: 'Stok geri eklendi',
};
